export type CallbackDayKey = 'Mo' | 'Di' | 'Mi' | 'Do' | 'Fr';
export type CallbackPeriod = 'Vormittag' | 'Nachmittag';

export interface CallbackDayOption {
  key: CallbackDayKey;
  label: string;
}

export type CallbackAvailabilitySelection = Record<CallbackDayKey, Record<CallbackPeriod, boolean>>;

export const CALLBACK_WEEKDAYS: readonly CallbackDayOption[] = [
  { key: 'Mo', label: 'Mo' },
  { key: 'Di', label: 'Di' },
  { key: 'Mi', label: 'Mi' },
  { key: 'Do', label: 'Do' },
  { key: 'Fr', label: 'Fr' },
];

export const CALLBACK_PERIODS: readonly CallbackPeriod[] = ['Vormittag', 'Nachmittag'];

export function createCallbackAvailabilitySelection(): CallbackAvailabilitySelection {
  return {
    Mo: { Vormittag: false, Nachmittag: false },
    Di: { Vormittag: false, Nachmittag: false },
    Mi: { Vormittag: false, Nachmittag: false },
    Do: { Vormittag: false, Nachmittag: false },
    Fr: { Vormittag: false, Nachmittag: false },
  };
}

export function setCallbackAvailabilitySlot(
  selection: CallbackAvailabilitySelection,
  dayKey: CallbackDayKey,
  period: CallbackPeriod,
  selected: boolean
): CallbackAvailabilitySelection {
  return {
    ...selection,
    [dayKey]: {
      ...selection[dayKey],
      [period]: selected,
    },
  };
}

export function formatCallbackAvailability(selection: CallbackAvailabilitySelection): string {
  return CALLBACK_WEEKDAYS
    .map((day) => {
      const periods = CALLBACK_PERIODS.filter((period) => selection[day.key][period]);
      return periods.length > 0 ? `${day.key} (${periods.join(', ')})` : '';
    })
    .filter(Boolean)
    .join(', ');
}
